import resume from '../assets/pdf/ManavResume.pdf'

export const headerData = {
    name: 'Manav Mangukiya',
    title: "Full-Stack Developer",
    desciption:"I’m passionate about helping businesses grow with robust and efficient web solutions. If you're looking for a reliable full-stack developer to bring your project to life, let's discuss your requirements!",
    image: 'https://firebasestorage.googleapis.com/v0/b/manavportfolio-22.appspot.com/o/potrait-manav.jpeg?alt=media&token=95346a41-6f0a-440a-ae89-668f6dee4c40',
    resumePdf: resume
}
